import { useVolvoCarsUrl } from '@vcc-www/volvo-cars-url';
import { getExtendedMarketSite } from './getMarketSite';

export const useCurrentMarketSite = () => {
  const { siteSlug } = useVolvoCarsUrl();
  return getExtendedMarketSite(siteSlug);
};
